/**
 * crewAuth.ts — shared manager-tier detection for the Crew App.
 *
 * Single source of truth for "who counts as a manager" on the client.
 * Must mirror the DB's public.crew_is_manager() function. If you change
 * one, change the other.
 */
import type { TeamMember } from "../../lib/types";

/** Roles with manager privileges (award SPIFFs, pin kickoffs, set goals). */
export const MANAGER_ROLES = new Set<string>([
  "admin",
  "sales_director",
  "roof_director",
  "director_of_operations",
  "roof_team_manager",
  "asm",
  "team_lead",
]);

/** Super users who bypass role allowlists everywhere in the portal. */
export const SUPER_USER_EMAILS = new Set<string>([
  "greg@bardinroofing.com",
  "chad@bardinroofing.com",
  "jennifer@bardinroofing.com",
  "jcohan@bardinroofing.com",
]);

/** True if the signed-in roster member is a Crew App manager. */
export function isCrewManager(member: TeamMember | null | undefined): boolean {
  if (!member) return false;
  if (SUPER_USER_EMAILS.has(member.email.toLowerCase())) return true;
  return MANAGER_ROLES.has(member.role);
}
